<template>
	<div class="chat-box" @click="onClickChatBox($event)" @mousemove="readedMessage()">
		<el-container>
			<el-header height="60px" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
				<div class="chat-title-wrap">
					<div class="title">{{ title }}</div>
					<div v-if="isPrivate" class="private-status-meta">
						<span class="status-dot" :class="friend.online ? 'online' : 'offline'"></span>
						<span class="status-text">{{ privateOnlineStatusText }}</span>
						<span v-if="privateIpText" class="meta-divider">|</span>
						<span v-if="privateIpText">IP: {{ privateIpText }}</span>
						<span v-if="privateAreaText" class="meta-divider">|</span>
						<span v-if="privateAreaText">{{ privateAreaText }}</span>
					</div>
				</div>
				<!-- <div v-if="chat.companyName" class="company-tag" :title="chat.companyName">@{{ chat.companyName }}</div> -->
				<span title="群聊信息" class="btn-side el-icon-more" @click="onClickMore"></span>
			</el-header>
			<el-main style="padding: 0;">
				<el-container class="chat-layout">
					<el-container class="content-box" :class="{ 'has-announcement': isGroup && group.notice }">
						
						<chat-announcement v-if="isGroup && group.notice" class="chat-announcement-fixed"
								:group="group"
								:announcement-info="group.notice"
								:scroll-speed="50" >
						</chat-announcement>
						<div v-if="isGroup" class="chat-group-top">
							<chat-top-message v-if=" group.topMessage" :group="group" :groupMembers="groupMembers" :msgInfo="group.topMessage"
								:headImage="headImage(group.topMessage)" :showName="showName(group.topMessage)"
								@locate="locateMessage" @remove-top="removeTopMessage" @hide-top="hideTopMessage">
							</chat-top-message>
						</div>
						<el-main class="im-chat-main" id="chatScrollBox" @mousedown.native.capture="hideSideOnChatMain"
							@touchstart.native.capture="hideSideOnChatMain" @click.native="hideSideOnChatMain" @scroll="onScroll">
					<div class="im-chat-box">
						<div v-for="(msgInfo, idx) in showMessages" :key="showMinIdx + idx">
							<chat-message-item :id="msgInfo.id" @call="onCall(msgInfo.type)"
						:active="activeMessageIdx == showMinIdx + idx" :mine="isMineMessage(msgInfo)"
						:headImage="headImage(msgInfo)" :showName="showName(msgInfo)" :msgInfo="msgInfo"
						:quoteShowName="showName(msgInfo.quoteMessage)" :group="group"
						:groupMembers="groupMembers" @locateQuote="onLocateQuoteMessage"
						@copy="onCopyMessage" @resend="onResendMessage" @delete="onDeleteMessage"
						@recall="onRecallMessage" @quote="onQuoteMessage" @top="onTopMessage"
						@forward="onForwardMessage"
						:multi-select-mode="multiSelectMode"
						:multi-select-mode-type="multiSelectModeType"
						:is-selected="isMessageSelected(msgInfo)"
						@start-multi-forward="onStartMultiForward"
						@start-multi-recall="onStartMultiRecall"
						@select-message="onSelectMessage" @at-user="onAtUser">
							</chat-message-item>
						</div>
					</div>
				</el-main>
						<div v-if="chat.atMe || chat.atAll" class="locate-tip" @click="scrollToAtMessage">有人@我 </div>
						<div v-else-if="!isInBottom" class="locate-tip" @click="scrollToBottom">
							{{ newMessageSize > 0 ? newMessageSize + '条新消息' : '回到底部' }}
						</div>
						<el-footer height="220px" class="im-chat-footer">
							<div class="chat-tool-bar">
								<div title="表情" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
									</div>
									<!-- 在多选模式下隐藏所有操作按钮 -->
									<div v-if="multiSelectMode" class="multi-select-mask"></div>
								<div v-if="configStore.electronMode" title="截图(CTRL + ALT + A)"
									class="icon iconfont icon-screenshot" ref="emotion" @click.stop="onScreenshot()">
								</div>
								<i v-if="configStore.electronMode" class="el-icon-caret-bottom"
									@click="onShowScreenshotMenu"></i>
								<div title="发送图片">
									<file-upload :action="'/image/upload'" :maxSize="10 * 1024 * 1024"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										:custom-upload="true" @before="onImageBefore" @upload="sendImageMessage"
										@success="onImageSuccess" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div title="发送视频">
									<file-upload :action="'/video/upload'" :maxSize="50 * 1024 * 1024"
										:fileTypes="['video/mp4', 'video/ogg', 'video/webm']" :custom-upload="true"
										@before="onVideoBefore" @upload="sendVideoMessage"
										@success="onVideoSuccess" @fail="onVideoFail">
										<i class="el-icon-film"></i>
									</file-upload>
								</div>
								<div title="发送文件">
									<file-upload ref="fileUpload" :action="'/file/upload'" :maxSize="10 * 1024 * 1024"
										:custom-upload="true" @before="onFileBefore" @upload="sendFileMessage"
										@success="onFileSuccess" @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
								<div v-if="canShareContactCard" title="发送个人名片" @click="onSendContactCard">
									<i class="el-icon-user"></i>
								</div>
								<div title="回执消息" v-show="isGroup" class="icon iconfont icon-receipt"
									:class="isReceipt ? 'chat-tool-active' : ''" @click="onSwitchReceipt">
								</div>
								<div title="发送语音" class="el-icon-microphone" @click="showRecordBox()">
								</div>
								<div title="语音通话" v-show="isPrivate" class="el-icon-phone-outline"
									@click="showPrivateVideo('voice')">
								</div>
								<div title="语音通话" v-show="isGroup" class="el-icon-phone-outline"
									@click="onGroupVideo()">
								</div>
								<div title="视频通话" v-show="isPrivate" class="el-icon-video-camera"
									@click="showPrivateVideo('video')">
								</div>
								<div title="聊天记录" class="el-icon-chat-dot-round" @click="showHistoryBox()"></div>
							</div>
							<div class="send-content-area">
								<ChatInput :group="group" ref="chatInputEditor" :group-members="groupMembers"
			@submit="sendMessage" :disabled="multiSelectMode" />
								<div v-if="quoteMessage" class="quote-message">
									<chat-quote-message :showName="showName(quoteMessage)" :msgInfo="quoteMessage">
									</chat-quote-message>
									<div class="quote-remove" @click="onQuoteMessage(null)"><i
											class="el-icon-close"></i></div>
								</div>
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion"
										@click="notifySend()">发送</el-button>
								</div>
							</div>
							<div class="chat-editer-mask" v-if="notAllowInputTip || multiSelectInputTip">
				<span class="icon el-icon-warning"></span>
				<span>{{ notAllowInputTip || multiSelectInputTip }}</span>
				
		
			</div>

		
				<div v-if="multiSelectMode" class="multi-select-bar" style="background: white; padding: 10px; display: flex; justify-content: flex-end; align-items: center; box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); z-index: 1000;">
					<div style="color: #606266; margin-right: 20px;">{{ selectedMessages.length }} 条消息</div>
					<div style="display: flex; gap: 10px;">
						<button v-if="multiSelectModeType === 'forward'" @click="onMultiForward" style="padding: 8px 16px; background: #409eff; color: white; border: none; border-radius: 4px; cursor: pointer;">转发</button>
						<button v-else-if="multiSelectModeType === 'recall'" @click="onMultiRecall" style="padding: 8px 16px; background: #f56c6c; color: white; border: none; border-radius: 4px; cursor: pointer;">撤回</button>
						<button @click="exitMultiSelectMode" style="padding: 8px 16px; background: #f0f2f5; color: #606266; border: none; border-radius: 4px; cursor: pointer;">取消</button>
					</div>
				</div>
			
			  
			
						</el-footer>
					</el-container>
					<transition name="chat-side-slide">
						<el-aside class="chat-side-box" :class="{ fullscreen: configStore.fullScreen }" width="265px"
							v-if="showSide">
							<chat-group-side v-if="isGroup" :chat="chat" :groupId="group.id || chat.targetId" :groupMembers="groupMembers"
								@reload="loadGroup($event || chat.targetId)" @operation-message="appendOperationTip"></chat-group-side>
							<chat-private-side v-if="isPrivate" :chat="chat" :userInfo="userInfo"></chat-private-side>
						</el-aside>
					</transition>
				</el-container>
			</el-main>
			<emotion ref="emoBox" @emotion="onEmotion"></Emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector v-if="isGroup" ref="rtcSel" :group="group" :groupMembers="groupMembers"
				@complete="onInviteOk"></group-member-selector>
			<chat-selector ref="chatSel" title="选择联系人" :group="group"></chat-selector>
			<rtc-group-join v-if="isGroup" ref="rtcJoin" :groupId="group.id"></rtc-group-join>
			<chat-history ref="chatHistory" :chat="chat" :friend="friend" :group="group" @locateQuote="locateMessage"
			:groupMembers="groupMembers" :mine="mine" 
			@start-multi-recall="onStartMultiRecall" 
			:multi-select-mode="multiSelectMode" :selected-messages="selectedMessages"
			@select-message="onSelectMessage"></chat-history>
			<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	


	</el-container>

	</div>
</template>

<script>
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatPrivateSide from "./ChatPrivateSide.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import Emotion from "../common/Emotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatAtBox from "./ChatAtBox.vue"
import GroupMemberSelector from "../group/GroupMemberSelector.vue"
import ChatSelector from "./ChatSelector.vue";
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue"
import ChatInput from "./ChatInput";
import ChatQuoteMessage from "./ChatQuoteMessage.vue";
import ChatTopMessage from "./ChatTopMessage.vue";
import configStore from "../../store/configStore";
import RightMenu from '../../components/common/RightMenu.vue';
import ChatAnnouncement from '../../components/chat/ChatAnnouncement.vue';
export default {
	name: "chatPrivate",
	components: {
		ChatInput,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		ChatPrivateSide,
		Emotion,
		ChatRecord,
		ChatHistory,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin,
		ChatQuoteMessage,
		ChatTopMessage,
		ChatSelector,
		RightMenu,
		ChatAnnouncement
	},
	props: {
		chat: {
			type: Object
		}
	},
	data() {
			return {
				userInfo: {},
				groupId: null,
				sendImageUrl: "",
				sendImageFile: "",
				placeholder: "",
				isReceipt: true, // 是否回执消息
				showRecord: false, // 是否显示语音录制弹窗
				showSide: false, // 是否显示群聊信息栏
				showMinIdx: 0, // 下标低于showMinIdx的消息不显示，否则页面会很卡
				showMaxIdx: -1, // 下标大于showMaxIdx的消息不显示，否则可能很卡,-1表示不限制
				activeMessageIdx: -1, //选择消息idx
				quoteMessage: null, // 被引用的消息
				reqQueue: [], // 等待发送的请求队列
				isSending: false, // 是否正在发消息
				isInBottom: true, // 滚动条是否在底部
				newMessageSize: 0, // 滚动条不在底部时新的消息数量
				maxTmpId: 0, // 最后生成的临时id
				// 新增多选转发相关状态
				multiSelectMode: false, // 是否处于多选模式
				selectedMessages: [], // 选中的消息列表
				multiSelectBarVisible: false, // 多选操作栏是否可见
				multiSelectInputTip: '', // 多选模式下的输入框禁止提示信息
				multiSelectModeType: 'forward', // 'forward'或'recall'
				historyLoading: false,
				historyFinished: false
			}
		},
	methods: {
		moveChatToTop() {
			this.chatStore.moveTop(this.chat);
		},
		hideSideOnChatMain() {
			if (this.showSide) {
				this.showSide = false;
			}
		},
		onClickChatBox(e) {
			// 关闭表情窗口
			this.$refs.emoBox.close();
			// 取消消息选中
			this.activeMessageIdx = -1;
			this.hideSideOnChatMainByEvent(e);
			// 如果不在多选模式，不做其他操作
			if (!this.multiSelectMode) {
				return;
			}
			// 在多选模式下，点击空白区域不退出多选模式
		},
		hideSideOnChatMainByEvent(e) {
			if (this.showSide && e && e.target && e.target.closest('.im-chat-main')) {
				this.showSide = false;
			}
		},
		onCall(type) {
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				this.showPrivateVideo('voice');
			} else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('video');
			}
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
			this.refreshPlaceHolder();
		},
		onImageSuccess(data, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt;
			this.sendMessageRequest(msgInfo).then(m => {
				msgInfo.id = m.id;
				msgInfo.status = m.status;
				this.isReceipt = false;
				this.chatStore.updateMessage(msgInfo, file.chat);
			}).catch(() => {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, file.chat);
			})
		},
		onImageFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
			this.chatStore.updateMessage(msgInfo, file.chat);
		},
		onImageBefore(file) {
			let url = URL.createObjectURL(file);
			let data = {
				originUrl: url,
				thumbUrl: url
			}
			let msgInfo = {
				tmpId: this.generateId(),
				fileId: file.uid,
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: this.$enums.MESSAGE_TYPE.IMAGE,
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.SENDING
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 借助file对象保存
			file.msgInfo = msgInfo;
			file.chat = this.chat;
			// 更新图片尺寸
			let chat = this.chat;
			file.imageSizePromise = this.getImageSize(file);
			file.imageSizePromise.then(size => {
				data.width = size.width;
				data.height = size.height;
				msgInfo.content = JSON.stringify(data)
				this.chatStore.updateMessage(msgInfo, chat);
				this.scrollToBottom();
			}).catch(() => {})
			return msgInfo;
		},
		onFileSuccess(url, file) {
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt
			this.sendMessageRequest(msgInfo).then((m) => {
				msgInfo.id = m.id;
				msgInfo.status = m.status;
				this.isReceipt = false;
				this.refreshPlaceHolder();
				this.chatStore.updateMessage(msgInfo, file.chat);
			}).catch(() => {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, file.chat);
			})
		},
		onFileFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
			this.chatStore.updateMessage(msgInfo, file.chat);
		},
		onFileBefore(file) {
			let url = URL.createObjectURL(file);
			let data = {
				name: file.name,
				size: file.size,
				url: url
			}
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: this.$enums.MESSAGE_TYPE.FILE,
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.SENDING
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 借助file对象透传
			file.msgInfo = msgInfo;
			file.chat = this.chat;
			return msgInfo;
		},
		onVideoSuccess(data, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.content = JSON.stringify(data);
			msgInfo.receipt = this.isReceipt;
			this.sendMessageRequest(msgInfo).then(m => {
				msgInfo.id = m.id;
				msgInfo.status = m.status;
				this.isReceipt = false;
				this.chatStore.updateMessage(msgInfo, file.chat);
			}).catch(() => {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, file.chat);
			})
		},
		onVideoFail(e, file) {
			let msgInfo = JSON.parse(JSON.stringify(file.msgInfo));
			msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
			this.chatStore.updateMessage(msgInfo, file.chat);
		},
		onVideoBefore(file) {
			let url = URL.createObjectURL(file);
			let data = {
				videoUrl: url
			}
			let msgInfo = {
				tmpId: this.generateId(),
				sendId: this.mine.id,
				content: JSON.stringify(data),
				sendTime: new Date().getTime(),
				selfSend: true,
				type: this.$enums.MESSAGE_TYPE.VIDEO,
				readedCount: 0,
				status: this.$enums.MESSAGE_STATUS.SENDING
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 插入消息
			this.chatStore.insertMessage(msgInfo, this.chat);
			// 会话置顶
			this.moveChatToTop();
			// 借助file对象透传
			file.msgInfo = msgInfo;
			file.chat = this.chat;
			// 更新视频尺寸
			let chat = this.chat;
			file.videoSizePromise = this.getVideoSize(file);
			file.videoSizePromise.then(size => {
				data.width = size.width;
				data.height = size.height;
				msgInfo.content = JSON.stringify(data)
				this.chatStore.updateMessage(msgInfo, chat);
				this.scrollToBottom();
			}).catch(() => {})
			return msgInfo;
		},
		onClickMore() {
			this.showSide = !this.showSide;
			if (this.showSide && this.isGroup) {
				// 刷新一下群和成员信息
				this.loadGroup(this.group.id);
			}
		},
			onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			// 滚到顶部
			if (scrollTop < 30) {
				if (this.showMinIdx > 0) {
					// 先展示当前已加载但未渲染的更早消息
					this.showMinIdx = this.showMinIdx > 20 ? this.showMinIdx - 20 : 0;
				} else {
					this.loadHistoryMessages(scrollElement);
				}
				// 清除底部标志
				this.isInBottom = false;
				this.refreshAtMessage();
			}
			// 滚到底部
			if (scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 30) {
				if (this.showMaxIdx > 0) {
					// 多展示20条信息
					this.showMaxIdx += 20;
				}
				// 已滚至消息底部
				if (this.showMaxIdx >= this.messageSize) {
					this.showMaxIdx = -1;
				}
				// 设置底部标志
				if (this.showMaxIdx < 0) {
					this.isInBottom = true;
					this.newMessageSize = 0;
				}
			}
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onScreenshot() {
			window.electronAPI.invoke('screenshot').then((buffer) => {
				if (buffer) {
					// 粘贴截图到聊天编辑框
					this.$refs.chatInputEditor.pasteScreenShot(buffer);
				}
			})
		},
		onShowScreenshotMenu(e) {
			let menuItems = [{
				key: 'SCREEN_SHOT',
				name: '截图时隐藏当前窗口',
			}];
			this.$refs.rightMenu.open(e, menuItems)
		},
		screenshotAndHideWin() {
			// 隐藏当前窗口
			window.electronAPI.sendEvent("close");
			setTimeout(() => {
				window.electronAPI.invoke('screenshot').then((buffer) => {
					if (buffer) {
						// 粘贴截图到聊天编辑框
						this.$refs.chatInputEditor.pasteScreenShot(buffer);
					}
					// 截图完成后还原窗口
					window.electronAPI.sendEvent("show");
				})
			}, 100)
		},
		onSelectMenu(item) {
			switch (item.key) {
				case "SCREEN_SHOT":
					this.screenshotAndHideWin();
					break;
			}
		},
		onEmotion(emoText) {
			this.$refs.chatInputEditor.insertEmoji(emoText);
		},
		onAtUser(member) {
			if (!this.isGroup || this.multiSelectMode || !member) {
				return;
			}
			this.$refs.chatInputEditor.insertAtMember(member);
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		showPrivateVideo(mode) {
			if (!this.isFriend) {
				this.$message.error("你已不是对方好友,无法呼叫");
				return
			}
			if (this.userStore.isInRtc) {
				this.$message.error("您已在通话中");
				return;
			}
			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			if (this.userStore.isInRtc) {
				this.$message.error("您已在通话中");
				return;
			}
			this.$http({
				url: "/webrtc/group/info?groupId=" + this.group.id,
				method: 'GET'
			}).then((rtcInfo) => {
				if (rtcInfo.isChating) {
					// 已在通话中，可以直接加入通话
					this.$refs.rtcJoin.open(rtcInfo);
				} else {
					// 邀请成员发起通话
					let ids = [this.mine.id];
					let maxChannel = this.configStore.webrtc.maxChannel;
					this.$refs.rtcSel.open(maxChannel, ids, ids, []);
				}
			})

		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true,
					isShareScreen: false
				})
			})
			let rtcInfo = {
				isHost: true,
				groupId: this.group.id,
				inviterId: this.mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);
		},
		showHistoryBox() {
			this.$refs.chatHistory.open();
		},
		onSendRecord(data) {
			let contentData = {
				duration: data.duration,
				url: data.url,
				size: data.size
			}
			let msgInfo = {
				tmpId: this.generateId(),
				content: JSON.stringify(contentData),
				type: this.$enums.MESSAGE_TYPE.AUDIO,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(msgInfo, this.chat.targetId);
			// 防止发送期间用户切换会话导致串扰
			const chat = this.chat;
			// 临时消息回显	
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			this.$yunxinIM.sendLegacyAudioMessage(chat, data.file, {}, null, contentData).then(m => {
				// 更新消息
				tmpMessage.id = m.id;
				tmpMessage.sendId = m.sendId;
				tmpMessage.recvId = m.recvId;
				tmpMessage.groupId = m.groupId;
				tmpMessage.sendTime = m.sendTime;
				tmpMessage.status = m.status;
				tmpMessage.content = m.content;
				tmpMessage.sourceMessage = m.sourceMessage;
				this.chatStore.updateMessage(tmpMessage, chat);
				// 保持输入框焦点
				this.$refs.chatInputEditor.focus();
				// 滚动到底部
				this.scrollToBottom();
				// 关闭录音窗口
				this.showRecord = false;
				this.isReceipt = false;
				this.refreshPlaceHolder();
			}).catch(() => {
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, chat);
			})
		},
		fillTargetId(msgInfo, targetId) {
			if (this.isGroup) {
				msgInfo.groupId = targetId;
			} else {
				msgInfo.recvId = targetId;
			}
		},
		isMineMessage(msgInfo) {
			if (!msgInfo) {
				return false;
			}
			if (msgInfo.selfSend) {
				return true;
			}
			return [
				this.mine.id,
				this.mine.accountId,
				this.mine.imAccid,
				this.$yunxinIM.currentAccount
			].filter(Boolean).some(id => String(id) === String(msgInfo.sendId));
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		async sendMessage(fullList) {
			this.resetEditor();
			this.readedMessage();
			let sendText = this.isReceipt ? "[回执消息] " : "";
			fullList.forEach(async msg => {
				switch (msg.type) {
					case "text":
						await this.sendTextMessage(sendText + msg.content, msg.atUserIds);
						break;
					case "image":
						await this.sendImageMessage(msg.content.file);
						break;
					case "video":
						await this.sendVideoMessage(msg.content.file);
						break;
					case "file":
						await this.sendFileMessage(msg.content.file);
						break;
				}
			})
		},
		async sendImageMessage(file) {
			const msgInfo = file.msgInfo || this.onImageBefore(file);
			const chat = file.chat;
			if (this.isGroup) {
				msgInfo.receipt = this.isReceipt;
			}
			try {
				const imageSize = await (file.imageSizePromise || Promise.resolve({})).catch(() => ({}));
				const m = await this.$yunxinIM.sendLegacyImageMessage(chat, file, this.buildMessageOptions(msgInfo), null, imageSize);
				msgInfo.id = m.id;
				msgInfo.sendId = m.sendId;
				msgInfo.recvId = m.recvId;
				msgInfo.groupId = m.groupId;
				msgInfo.sendTime = m.sendTime;
				msgInfo.status = m.status;
				msgInfo.content = m.content;
				msgInfo.sourceMessage = m.sourceMessage;
				this.isReceipt = false;
				this.chatStore.updateMessage(msgInfo, chat);
				this.scrollToBottom();
			} catch (e) {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, chat);
				throw e;
			} finally {
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			}
		},
		async sendVideoMessage(file) {
			const msgInfo = file.msgInfo || this.onVideoBefore(file);
			const chat = file.chat;
			if (this.isGroup) {
				msgInfo.receipt = this.isReceipt;
			}
			try {
				const videoSize = await (file.videoSizePromise || Promise.resolve({})).catch(() => ({}));
				const m = await this.$yunxinIM.sendLegacyVideoMessage(chat, file, this.buildMessageOptions(msgInfo), null, videoSize);
				msgInfo.id = m.id;
				msgInfo.sendId = m.sendId;
				msgInfo.recvId = m.recvId;
				msgInfo.groupId = m.groupId;
				msgInfo.sendTime = m.sendTime;
				msgInfo.status = m.status;
				msgInfo.content = m.content;
				msgInfo.sourceMessage = m.sourceMessage;
				this.isReceipt = false;
				this.chatStore.updateMessage(msgInfo, chat);
				this.scrollToBottom();
			} catch (e) {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, chat);
				throw e;
			} finally {
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			}
		},
		sendTextMessage(sendText, atUserIds) {
			return new Promise((resolve, reject) => {
				if (!sendText.trim()) {
					reject();
				}
				let msgInfo = {
					tmpId: this.generateId(),
					content: sendText,
					type: this.$enums.MESSAGE_TYPE.TEXT
				}
				// 填充对方id
				this.fillTargetId(msgInfo, this.chat.targetId);
				// 被@人员列表
				if (this.isGroup) {
					msgInfo.atUserIds = atUserIds;
					msgInfo.receipt = this.isReceipt;
				}
				// 引用消息
				if (this.quoteMessage) {
					msgInfo.quoteMessageId = this.quoteMessage.id;
					msgInfo.quoteMessage = this.buildQuoteMessage(this.quoteMessage);
				}
				// 防止发送期间用户切换会话导致串扰
				const chat = this.chat;
				// 回显消息
				let tmpMessage = this.buildTmpMessage(msgInfo);
				this.chatStore.insertMessage(tmpMessage, chat);
				this.moveChatToTop();
				// 发送
				this.$yunxinIM.sendLegacyTextMessage(chat, sendText, this.buildMessageOptions(msgInfo)).then(m => {
					// 更新消息
					tmpMessage.id = m.id;
					tmpMessage.sendId = m.sendId;
					tmpMessage.recvId = m.recvId;
					tmpMessage.groupId = m.groupId;
					tmpMessage.sendTime = m.sendTime;
					tmpMessage.status = m.status;
					tmpMessage.content = m.content;
					tmpMessage.quoteMessage = m.quoteMessage || msgInfo.quoteMessage;
					tmpMessage.sourceMessage = m.sourceMessage;
					this.chatStore.updateMessage(tmpMessage, chat);
					this.scrollToBottom();
				}).catch(() => {
					// 更新消息
					tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
					this.chatStore.updateMessage(tmpMessage, chat);
				}).finally(() => {
					this.isReceipt = false;
					this.quoteMessage = null;
					resolve();
				});
			});
		},
		buildQuoteMessage(msgInfo) {
			if (!msgInfo) {
				return null;
			}
			return {
				id: msgInfo.id,
				tmpId: msgInfo.tmpId,
				sendId: msgInfo.sendId,
				recvId: msgInfo.recvId,
				groupId: msgInfo.groupId,
				content: msgInfo.content,
				type: msgInfo.type,
				status: msgInfo.status,
				sendTime: msgInfo.sendTime,
				sendNickName: msgInfo.sendNickName,
				selfSend: this.isMineMessage(msgInfo)
			};
		},
		buildMessageOptions(msgInfo) {
			const extension = {};
			const options = {};
			if (msgInfo.quoteMessage) {
				extension.quoteMessage = msgInfo.quoteMessage;
			}
			if (msgInfo.atUserIds && msgInfo.atUserIds.length) {
				extension.atUserIds = msgInfo.atUserIds;
			}
			if (msgInfo.receipt) {
				extension.teamReceiptMessage = true;
				options.messageConfig = { readReceiptEnabled: true };
			}
			if (Object.keys(extension).length) {
				options.serverExtension = extension;
			}
			return options;
		},
		async sendFileMessage(file) {
			if (!file.msgInfo && this.$refs.fileUpload && !this.$refs.fileUpload.beforeUpload(file)) {
				return;
			}
			const msgInfo = file.msgInfo || this.onFileBefore(file);
			const chat = file.chat;
			if (this.isGroup) {
				msgInfo.receipt = this.isReceipt;
			}
			try {
				const m = await this.$yunxinIM.sendLegacyFileMessage(chat, file, this.buildMessageOptions(msgInfo));
				msgInfo.id = m.id;
				msgInfo.sendId = m.sendId;
				msgInfo.recvId = m.recvId;
				msgInfo.groupId = m.groupId;
				msgInfo.sendTime = m.sendTime;
				msgInfo.status = m.status;
				msgInfo.content = m.content;
				msgInfo.sourceMessage = m.sourceMessage;
				this.isReceipt = false;
				this.refreshPlaceHolder();
				this.chatStore.updateMessage(msgInfo, chat);
				this.scrollToBottom();
			} catch (e) {
				msgInfo.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(msgInfo, chat);
				throw e;
			} finally {
				this.$nextTick(() => this.$refs.chatInputEditor.focus());
				this.scrollToBottom();
			}
		},
		onCopyMessage(msgInfo) {
			// 使用现代浏览器的 Clipboard API
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(msgInfo.content).then(() => {
					this.$message.success('内容已复制到剪贴板');
				}).catch(() => {
					this.$message.error('复制失败，请手动复制');
				});
			} else {
				this.$message.error('复制失败，请手动复制');
			}
		},
		onResendMessage(msgInfo) {
			if (msgInfo.type != this.$enums.MESSAGE_TYPE.TEXT) {
				this.$message.error("该消息不支持自动重新发送，建议手动重新发送")
				return;
			}
			// 防止发送期间用户切换会话导致串扰
			const chat = this.chat;
			// 删除旧消息
			this.chatStore.deleteMessage(msgInfo, chat);
			// 重新推送
			msgInfo.tmpId = this.generateId();
			let tmpMessage = this.buildTmpMessage(msgInfo);
			this.chatStore.insertMessage(tmpMessage, chat);
			this.moveChatToTop();
			// 发送
			this.sendMessageRequest(msgInfo).then(m => {
				// 更新消息
				tmpMessage.id = m.id;
				tmpMessage.status = m.status;
				tmpMessage.content = m.content;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).catch(() => {
				// 更新消息
				tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				this.chatStore.updateMessage(tmpMessage, chat);
			}).finally(() => {
				this.scrollToBottom();
			});
		},
		onDeleteMessage(msgInfo) {
			this.$confirm('确认删除消息?', '删除消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.chatStore.deleteMessage(msgInfo, this.chat);
			});
		},
		onRecallMessage(msgInfo) {
			if (!this.canRecallMessage(msgInfo)) {
				this.$message.warning('没有权限撤回该消息');
				return;
			}
			this.$confirm('确认撤回消息?', '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.recallOneMessage(msgInfo).then((m) => {
					this.$message.success("消息已撤回");
					this.chatStore.recallMessage(m, this.chat);
				}).catch(error => {
					console.warn('[ChatBox] 云信消息撤回失败:', error);
					this.$message.error(this.getRecallErrorMessage(error));
				})
			});
		},
		onQuoteMessage(msgInfo) {
			this.quoteMessage = msgInfo;
		},
		onForwardMessage(msgInfo) {
			this.$refs.chatSel.open(chats => {
				this.sendForwardMessages([msgInfo], chats);
			});
		},
		// 修改：使用现有的ChatSelector组件实现分享名片功能
		onSendContactCard() {
			if (!this.canShareContactCard) {
				this.$message.warning('当前群设置不允许普通成员分享名片');
				return;
			}
			// 关闭其他打开的面板
			this.$refs.emoBox.close();
			
			// 使用现有的ChatSelector组件打开联系人选择器
			this.$refs.chatSel.open(contacts => {
				if (!contacts || contacts.length === 0) return;
				const chat = this.chat;
				
				contacts.forEach(contact => {
					let msgInfo;
					let cardData;
					
					
					// 根据联系人类型构建不同的名片消息
					if (contact.type === 'GROUP') {
						// 修复：通过targetId从groupStore获取完整的群组信息
						let fullGroupInfo = this.groupStore.findGroup(contact.targetId);
						
						// 群名片消息 - GROUP_CARD类型
						cardData = {
							groupId: fullGroupInfo.id,
							groupName: fullGroupInfo.groupName || fullGroupInfo.showGroupName,
							headImage: fullGroupInfo.headImage || fullGroupInfo.headImageThumb
						};
						
						msgInfo = {
							tmpId: this.generateId(),
							content: JSON.stringify(cardData),
							type: this.$enums.MESSAGE_TYPE.GROUP_CARD,
							receipt: this.isReceipt
						};
					} else {
						// 修复：通过targetId从friendStore获取完整的好友信息
						let fullFriendInfo = this.friendStore.findFriend(contact.targetId);
						
						// 好友名片消息 - USER_CARD类型
						cardData = {
							userId: fullFriendInfo.imAccid || fullFriendInfo.accountId || fullFriendInfo.accid || fullFriendInfo.id,
							accid: fullFriendInfo.imAccid || fullFriendInfo.accountId || fullFriendInfo.accid || fullFriendInfo.id,
							nickName: fullFriendInfo.nickName || fullFriendInfo.showNickName,
							headImage: fullFriendInfo.headImage
						};
						
						msgInfo = {
							tmpId: this.generateId(),
							content: JSON.stringify(cardData),
							type: this.$enums.MESSAGE_TYPE.USER_CARD,
							receipt: this.isReceipt
						};
					}
					
					// 填充目标ID
					this.fillTargetId(msgInfo, this.chat.targetId);
					
					// 确保消息包含必要字段
					if (this.isGroup) {
						msgInfo.groupId = this.chat.targetId;
					} else {
						msgInfo.recvId = this.chat.targetId;
					}
					
					// 创建临时消息用于回显
					let tmpMessage = this.buildTmpMessage(msgInfo);
					this.chatStore.insertMessage(tmpMessage, chat);
					
					// 会话置顶
					this.moveChatToTop();
					
					// 发送请求
					this.$yunxinIM.sendLegacyCardMessage(chat, msgInfo.type, cardData).then(m => {
						// 更新消息
						tmpMessage.id = m.id;
						tmpMessage.sendId = m.sendId;
						tmpMessage.recvId = m.recvId;
						tmpMessage.groupId = m.groupId;
						tmpMessage.sendTime = m.sendTime;
						tmpMessage.status = m.status;
						tmpMessage.content = m.content;
						tmpMessage.sourceMessage = m.sourceMessage;
						this.chatStore.updateMessage(tmpMessage, chat);
						
						// 滚动到底部
						this.scrollToBottom();
						
						// 重置回执状态
						this.isReceipt = false;
					}).catch(() => {
						tmpMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
						this.chatStore.updateMessage(tmpMessage, chat);
					});
				});
				
				this.$message.success(`成功发送名片到${contacts.length}个联系人`);
			}, '选择联系人发送名片'); // 传递标题参数
		},
		// 开始多选模式
startMultiSelectMode(modeType = 'forward') {
    this.multiSelectMode = true;
    this.multiSelectModeType = modeType;
    this.selectedMessages = [];
    this.multiSelectInputTip = '点击消息选择';
},
		// 退出多选模式
		exitMultiSelectMode() {
			this.multiSelectMode = false;
			this.multiSelectModeType = 'default';
			this.selectedMessages = [];
			this.multiSelectInputTip = '';
		},
		// 判断消息是否被选中
		isMessageSelected(msgInfo) {
			return this.selectedMessages.some(msg => msg.id === msgInfo.id);
		},
		// 处理消息选择
		onSelectMessage(msgInfo) {
			const index = this.selectedMessages.findIndex(msg => msg.id === msgInfo.id);
			if (index > -1) {
				// 取消选择
				this.selectedMessages.splice(index, 1);
			} else {
				// 选择消息
				this.selectedMessages.push(msgInfo);
			}
		},
		// 多选转发
		onMultiForward() {
			if (this.selectedMessages.length === 0) {
				return;
			}
			
			// 按照消息发送时间排序，确保按照时间顺序转发
			const sortedMessages = [...this.selectedMessages].sort((a, b) => {
				return a.sendTime - b.sendTime;
			});
			
			this.$refs.chatSel.open(chats => {
				this.sendForwardMessages(sortedMessages, chats).finally(() => {
					// 转发完成后退出多选模式
					this.exitMultiSelectMode();
				});
			});
		},
		
		// 处理多选转发菜单点击事件
		onStartMultiForward() {
			this.startMultiSelectMode('forward');
		},
		// 处理多选撤回菜单点击事件
		onStartMultiRecall() {
			this.startMultiSelectMode('recall'); // 启动多选撤回模式
		},
		
		// 多选撤回方法
		onMultiRecall() {
			if (this.selectedMessages.length === 0) {
				return;
			}
			
			// 过滤出有权限撤回的消息
			let messagesCanRecall = this.selectedMessages.filter(msg => {
				return this.canRecallMessage(msg);
			});
			
			if (messagesCanRecall.length === 0) {
				this.$message.warning('没有可撤回的消息（需要是群主、管理员或自己发送的消息）');
				return;
			}
			
			// 如果有部分消息没有权限撤回，提示用户
			if (messagesCanRecall.length < this.selectedMessages.length) {
				this.$message.warning(`只有 ${messagesCanRecall.length} 条消息有权限撤回`);
			}
			
			// 确认撤回
			this.$confirm(`确认撤回选中的 ${messagesCanRecall.length} 条消息?`, '撤回消息', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				// 按照消息发送时间倒序撤回（新消息先撤回）
				const sortedMessages = [...messagesCanRecall].sort((a, b) => {
					return b.sendTime - a.sendTime;
				});
				
				this.recallMessagesInSequence(sortedMessages);
			});
		},
		
		// 检查是否有权限撤回消息
		canRecallMessage(msgInfo) {
			// 群主、管理员或自己发送的消息可以撤回
			return !!msgInfo?.id && (this.isOwner || this.isManager || msgInfo.selfSend);
		},
		recallOneMessage(msgInfo) {
			return this.$yunxinIM.recallLegacyMessage(msgInfo, {
				postscript: '撤回了一条消息'
			});
		},
		isRecallTimeoutError(error) {
			const message = String(error?.message || '').toLowerCase();
			return Number(error?.code) === 107314 || message.includes('exceed time limit');
		},
		getRecallErrorMessage(error) {
			if (this.isRecallTimeoutError(error)) {
				return '消息已超过可撤回时间，无法撤回';
			}
			return error?.message || '撤回失败';
		},
		
		// 按顺序撤回消息
		recallMessagesInSequence(messages) {
			let total = messages.length;
			let successCount = 0;
			let failCount = 0;
			let timeoutCount = 0;
			
			const recallNextMessage = (index) => {
				if (index >= total) {
					// 所有消息处理完成
					if (successCount > 0) {
						this.$message.success(`成功撤回 ${successCount} 条消息`);
					}
					if (failCount > 0) {
						const timeoutText = timeoutCount > 0 ? `，其中 ${timeoutCount} 条已超时` : '';
						this.$message.warning(`${failCount} 条消息撤回失败${timeoutText}`);
					}
					this.exitMultiSelectMode();
					return;
				}
				
				const msgInfo = messages[index];
				this.recallOneMessage(msgInfo).then((m) => {
					successCount++;
					this.chatStore.recallMessage(m, this.chat);
					
					// 继续撤回下一条消息
					recallNextMessage(index + 1);
				}).catch(error => {
					failCount++;
					if (this.isRecallTimeoutError(error)) {
						timeoutCount++;
					}
					// 某条消息撤回失败，继续撤回其他消息
					recallNextMessage(index + 1);
				});
			};
			
			// 开始撤回第一条消息
			recallNextMessage(0);
		},
		// 发送转发消息的通用方法
		async sendForwardMessages(messages, chats) {
			if (!messages.length || !chats.length) {
				return;
			}
			const total = messages.length * chats.length;
			let completed = 0;
			let successCount = 0;
			let failCount = 0;
			const loading = this.$loading({
				lock: true,
				text: `正在转发 0/${total}`,
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.35)'
			});
			const updateProgress = () => {
				const text = `正在转发 ${completed}/${total}`;
				if (loading.setText) {
					loading.setText(text);
				} else {
					loading.text = text;
				}
			};
			try {
				for (const chat of chats) {
					for (const msgInfo of messages) {
						try {
							const m = await this.$yunxinIM.forwardLegacyMessage(chat, msgInfo);
							this.chatStore.openChat(chat);
							this.chatStore.insertMessage(m, chat);
							successCount++;
						} catch (error) {
							console.warn('[ChatBox] 云信消息转发失败:', error);
							failCount++;
						} finally {
							completed++;
							updateProgress();
						}
					}
				}
			} finally {
				loading.close();
			}
			if (successCount > 0) {
				this.$message.success(`成功转发 ${successCount}/${total} 条消息`);
			}
			if (failCount > 0) {
				this.$message.warning(`${failCount} 条消息转发失败`);
			}
		},
		async onTopMessage(msgInfo) {
			try {
				await this.updateGroupTopMessage(msgInfo);
				this.$message.success('已置顶消息');
			} catch (error) {
				console.error('[ChatBox] 置顶消息失败:', error);
				this.$message.error(error?.message || '置顶消息失败');
			}
		},
		async removeTopMessage() {
			try {
				await this.updateGroupTopMessage(null);
				this.$message.success('已移除置顶消息');
			} catch (error) {
				console.error('[ChatBox] 移除置顶消息失败:', error);
				this.$message.error(error?.message || '移除置顶消息失败');
			}
		},
		hideTopMessage() {
			const groupId = this.group.id || this.chat.targetId;
			if (groupId) {
				this.groupStore.updateTopMessage(groupId, null);
			}
		},
		async updateGroupTopMessage(msgInfo = null) {
			const groupId = this.group.id || this.chat.targetId || msgInfo?.groupId;
			if (!this.isGroup || !groupId) {
				throw new Error('当前不是群聊');
			}
			if (msgInfo && !msgInfo.id) {
				throw new Error('无法置顶该消息');
			}
			let teamType = this.group?.teamType || 1;
			let team = await this.$yunxinIM.getTeamInfo(groupId, teamType).catch(async error => {
				if (teamType !== 2) {
					teamType = 2;
					return this.$yunxinIM.getTeamInfo(groupId, teamType);
				}
				throw error;
			});
			const nextServerExtension = {
				...this.parseGroupExtension(team)
			};
			if (msgInfo) {
				nextServerExtension.topMessage = this.normalizeTopMessagePayload({
					...msgInfo,
					groupId
				});
			} else {
				delete nextServerExtension.topMessage;
			}
			await this.$yunxinIM.updateTeamInfo(groupId, team.teamType || teamType, {
				serverExtension: Object.keys(nextServerExtension).length ? JSON.stringify(nextServerExtension) : ''
			});
			this.groupStore.updateTopMessage(groupId, nextServerExtension.topMessage || null);
		},
		onLocateQuoteMessage(msgInfo) {
			this.locateMessage(msgInfo.quoteMessage);
		},
		locateMessage(msgInfo) {
			// 寻找消息位置
			const idx = this.findMessageIdx(msgInfo);
			if (idx < 0) {
				this.$message.error("无法定位原消息");
				return;
			}
			// 要定位到消息，首先要渲染这条消息
			this.showMinIdx = Math.max(idx - 10, 0);
			this.showMaxIdx = this.showMinIdx + 20;
			// 定位消息
			this.scrollToMessage(msgInfo.id, 100, 0);
			// 选中消息
			this.activeMessageIdx = idx;
			// 设置底部标记
			if (this.showMaxIdx > 0 && this.showMaxIdx < this.messageSize) {
				// 延时是为了在滚动事件触发之后设置
				setTimeout(() => {
					this.isInBottom = false;
					this.newMessageSize = 0;
				}, 100)
			}
			this.$refs.chatHistory.close();
		},
		scrollToMessage(id, delay, times) {
			setTimeout(() => {
				let messgaeItem = document.getElementById(id);
				if (messgaeItem) {
					messgaeItem.scrollIntoView({ behavior: 'smooth' });
				} else if (times < 3) {
					this.scrollToMessage(id, delay * 3, times + 1)
				} else {
					console.log("消息定位失败", delay)
				}
			}, delay)
		},
		scrollToAtMessage() {
			this.locateMessage({ id: this.chat.lastAtMessageId });
			this.chatStore.resetAtMessage(this.chat);
		},
		resetShowMessages() {
			// 初始状态仅渲染最近50条数据
			this.showMinIdx = this.messageSize > 50 ? this.messageSize - 50 : 0;
			this.showMaxIdx = -1;
			this.refreshAtMessage();
		},
		refreshAtMessage() {
			// @我的消息已读，需要清除“有人@我”标志
			if (this.chat.atMe || this.chat.atAll) {
				const idx = this.findMessageIdx({ id: this.chat.lastAtMessageId });
				if (this.showMinIdx < idx) {
					this.chatStore.resetAtMessage(this.chat);
				}
			}
		},
		findMessageIdx(msgInfo) {
			for (let idx in this.chat.messages) {
				const message = this.chat.messages[idx];
				// 通过id判断
				if (msgInfo.id && message.id && message.id == msgInfo.id) {
					return idx;
				}
				// 正在发送中的消息可能没有id,只有tmpId
				if (msgInfo.tmpId && message.tmpId && message.tmpId == msgInfo.tmpId) {
					return idx;
				}
			}
			return -1;
		},
		async readedMessage() {
			if (this.chat.unreadCount > 0) {
				const receiptMessages = await this.$yunxinIM.markConversationRead(this.chat).catch(error => {
					console.warn('[ChatBox] 云信会话已读失败:', error);
					return [];
				});
				(receiptMessages || []).forEach(message => this.chatStore.updateMessage(message, this.chat));
				this.chatStore.resetUnreadCount(this.chat)
			}
		},
		loadReaded(fId) {
			if (!this.chat || this.chat.type !== 'PRIVATE' || String(this.chat.targetId) !== String(fId)) {
				return;
			}
			const messages = this.$yunxinIM.refreshPeerReadStatus(this.chat.messages || []);
			let updated = false;
			messages.forEach(message => {
				if (message.status === this.$enums.MESSAGE_STATUS.READED) {
					updated = true;
				}
				this.chatStore.updateMessage(message, this.chat);
			});
			if (updated) {
				this.chat.stored = false;
				this.chatStore.saveToStorage();
			}
		},
		async loadGroup(groupId) {
			groupId = groupId || this.chat.targetId;
			if (!groupId) {
				console.warn('[ChatBox] 群ID为空，跳过加载群聊');
				return;
			}
			this.groupId = groupId;
			try {
				let teamType = this.group?.teamType || 1;
				let team = await this.$yunxinIM.getTeamInfo(groupId, teamType).catch(async error => {
					if (teamType !== 2) {
						teamType = 2;
						return this.$yunxinIM.getTeamInfo(groupId, teamType);
					}
					throw error;
				});
				const members = await this.loadSdkGroupMembers(groupId, team.teamType || teamType);
				const group = this.normalizeSdkGroup(team, members);
				this.chatStore.updateChatFromGroup(group);
				if (this.groupStore.findGroup(group.id)) {
					this.groupStore.updateGroup(group);
				} else {
					this.groupStore.addGroup(group);
				}
			} catch (error) {
				console.error('[ChatBox] 加载云信群聊失败:', error);
				this.$message.error(error?.message || '加载群聊失败');
			}
		},
		isIdLikeName(name, accountId = '') {
			const value = String(name || '');
			if (!value) return true;
			if (accountId && value === String(accountId)) return true;
			return /^[a-f0-9]{24,}$/i.test(value) || /^[0-9]{8,}$/.test(value);
		},
		mergeMemberProfile(member, oldMember = {}, profile = {}) {
			const accountId = String(member.accountId || member.teamMemberAccountId || member.memberAccountId || member.userId || '');
			const profileName = profile.showNickName || profile.nickName || profile.name || '';
			const oldName = oldMember.showNickName || oldMember.nickName || '';
			const memberTeamNick = member.teamNick || member.nickName || '';
			const nickName = !this.isIdLikeName(memberTeamNick, accountId)
				? memberTeamNick
				: (!this.isIdLikeName(profileName, accountId) ? profileName : oldName || accountId);
			const headImage = profile.headImageThumb || profile.headImage || profile.avatar || oldMember.headImage || oldMember.headImageThumb || '';
			return { nickName, headImage };
		},
		parseGroupExtension(team = {}) {
			const rawExtension = team.serverExtension || team.ext || '';
			if (!rawExtension) {
				return {};
			}
			try {
				return typeof rawExtension === 'string' ? JSON.parse(rawExtension) : rawExtension;
			} catch (error) {
				console.warn('[ChatBox] 解析群扩展字段失败:', error);
				return {};
			}
		},
		normalizeTopMessagePayload(msgInfo = {}) {
			return {
				id: msgInfo.id,
				tmpId: msgInfo.tmpId,
				groupId: msgInfo.groupId || this.group.id || this.chat.targetId,
				sendId: msgInfo.sendId,
				sendTime: msgInfo.sendTime,
				type: msgInfo.type,
				content: msgInfo.content || '',
				status: msgInfo.status,
				selfSend: !!msgInfo.selfSend,
				receipt: !!msgInfo.receipt,
				readedCount: Number(msgInfo.readedCount || 0)
			};
		},
		normalizeSdkGroup(team = {}, members = []) {
			const groupExt = this.parseGroupExtension(team);
			const teamId = team.teamId || team.id || this.groupId;
			const oldGroup = this.groupStore.findGroup(teamId) || this.group || {};
			const finalMembers = members.length ? members : (oldGroup.members || []);
			const chatBannedMode = Number(team.chatBannedMode ?? team.teamChatBannedMode ?? 0);
			const remarkGroupName = this.group.remarkGroupName || this.chat.remarkGroupName || '';
			const mineAccountId = this.mine.imAccid || this.mine.accountId || this.mine.id || this.$yunxinIM.currentAccount;
			const myMember = finalMembers.find(member => String(member.userId || '') === String(mineAccountId || '')) || {};
			const groupName = team.name || this.chat.showName || '';
			const teamMemberCount = Number(team.memberCount);
			const memberCount = Number.isFinite(teamMemberCount) ? teamMemberCount : finalMembers.length;
			return {
				id: teamId,
				teamType: team.teamType || team.type || 1,
				name: groupName,
				showGroupName: remarkGroupName || groupName,
				remarkGroupName,
				remarkNickName: myMember.showNickName || myMember.nickName || this.group.remarkNickName || '',
				headImage: team.avatar || this.chat.headImage || '',
				headImageThumb: team.avatar || this.chat.headImage || '',
				notice: team.announcement || '',
				intro: team.intro || '',
				serverExtension: team.serverExtension || team.ext || '',
				ownerId: team.ownerAccountId || team.ownerId || '',
				members: finalMembers,
				memberCount,
				quit: false,
				isAllMuted: chatBannedMode === 1 || chatBannedMode === 3,
				isDnd: this.group.isDnd || false,
				isTop: this.group.isTop || false,
				sdkCreated: true,
				allowAddFriend: groupExt.allowAddFriend !== false,
				isAllowInvite: Number(team.inviteMode) === 1,
				isAllowShareCard: groupExt.isAllowShareCard !== false,
				topMessage: groupExt.topMessage || null
			};
		},
		async loadSdkGroupMembers(groupId, teamType) {
			const sdkMembers = await this.$yunxinIM.getTeamMemberList(groupId, teamType).catch(() => []);
			const accountIds = sdkMembers.map(member => String(member.accountId || member.teamMemberAccountId || member.memberAccountId || '')).filter(Boolean);
			const profiles = await this.$yunxinIM.getUserProfiles(accountIds).catch(() => []);
			const profileMap = profiles.reduce((map, profile) => {
				map[String(profile.accountId || profile.id)] = profile;
				return map;
			}, {});
			const oldMembers = this.groupStore.findGroup(groupId)?.members || this.group?.members || [];
			return sdkMembers.map(member => {
				const accountId = String(member.accountId || member.teamMemberAccountId || member.memberAccountId || '');
				const profile = profileMap[accountId] || {};
				const oldMember = oldMembers.find(item => String(item.userId || item.accountId || item.imAccid || '') === accountId) || {};
				const { nickName, headImage } = this.mergeMemberProfile(member, oldMember, profile);
				const role = member.memberRole ?? member.teamMemberRole ?? member.role ?? 0;
				const numericRole = Number(role);
				return {
					userId: accountId,
					role: numericRole,
					nickName: member.teamNick || nickName,
					showNickName: member.teamNick || nickName,
					headImage: headImage,
					online: false,
					isManager: numericRole === 2 || String(role).toLowerCase().includes('manager'),
					isMuted: !!(member.chatBanned || member.isMuted),
					quit: false,
					version: Number(member.updateTime || member.createTime || 0)
				};
			});
		},
		updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				let friend = JSON.parse(JSON.stringify(this.friend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.lastLoginIp = this.privateIpText;
				friend.lastLoginArea = this.privateAreaText;
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
				this.chatStore.updateChatFromFriend(friend);
				this.friendStore.updateFriend(friend);
			} else {
				this.chatStore.updateChatFromUser(this.userInfo);
			}
		},
		loadFriend(friendId) {
			// 获取好友信息
			const id = String(friendId);
			const isNumericId = /^\d+$/.test(id);
			this.$http({
				url: isNumericId ? `/user/find/${id}` : `/user/findByAccid/${id}`,
				method: 'GET'
			}).then((userInfo) => {
				this.userInfo = userInfo;
				this.updateFriendInfo();
			})
		},
		async loadRecentMessages() {
			if (!this.chat || !this.chat.targetId || this.chat.type === 'SYSTEM') {
				return;
			}
			const loadingChat = this.chat;
			try {
				const messages = await this.$yunxinIM.getRecentMessages(this.chat, 50);
				if (loadingChat !== this.chat) {
					return;
				}
				const currentMessages = (this.chat.messages || []).filter(message => message.type !== this.$enums.MESSAGE_TYPE.TIP_TIME);
				this.chat.messages = this.buildMessagesWithTimeTips(this.mergeUniqueMessages(messages, currentMessages));
				this.historyFinished = messages.length < 50;
				this.chat.hotMinIdx = this.chat.messages.length;
				this.chat.readedMessageIdx = this.getLastReadedMessageIdx(this.chat.messages);
				this.chat.stored = false;
				this.chatStore.saveToStorage(true);
				this.resetShowMessages();
				this.scrollToBottom();
			} catch (error) {
				console.warn('[ChatBox] 加载最近消息失败:', error);
			}
		},
		appendOperationTip(content) {
			if (!content || !this.chat) {
				return;
			}
			const sendTime = Date.now();
			const tipMessage = {
				id: `operation_${this.chat.targetId}_${sendTime}`,
				tmpId: `operation_${this.chat.targetId}_${sendTime}`,
				sendId: this.mine.imAccid || this.mine.accountId || this.mine.id,
				groupId: this.chat.targetId,
				content,
				type: this.$enums.MESSAGE_TYPE.TIP_TEXT,
				status: this.$enums.MESSAGE_STATUS.DELIVERED,
				sendTime,
				selfSend: true,
				chatType: 'GROUP'
			};
			const currentMessages = (this.chat.messages || []).filter(message => message.type !== this.$enums.MESSAGE_TYPE.TIP_TIME);
			this.chat.messages = this.buildMessagesWithTimeTips(this.mergeUniqueMessages(currentMessages, [tipMessage]));
			this.scrollToBottom();
		},
		buildMessagesWithTimeTips(messages = []) {
			const result = [];
			let lastTipTime = 0;
			messages
				.filter(message => message.type !== this.$enums.MESSAGE_TYPE.TIP_TIME)
				.sort((a, b) => Number(a.sendTime || 0) - Number(b.sendTime || 0))
				.forEach(message => {
					const sendTime = Number(message.sendTime || Date.now());
					if (!lastTipTime || sendTime - lastTipTime >= 10 * 60 * 1000) {
						result.push({
							id: `time_${sendTime}`,
							tmpId: `time_${sendTime}`,
							sendTime,
							type: this.$enums.MESSAGE_TYPE.TIP_TIME
						});
						lastTipTime = sendTime;
					}
					result.push(message);
				});
			return result;
		},
		mergeUniqueMessages(baseMessages = [], appendMessages = []) {
			const result = [];
			const exists = new Map();
			baseMessages.concat(appendMessages).forEach(message => {
				const key = String(message.id || message.messageClientId || message.tmpId || '');
				if (key && exists.has(key)) {
					const oldMessage = exists.get(key);
					if (message.status === this.$enums.MESSAGE_STATUS.READED && oldMessage.status !== this.$enums.MESSAGE_STATUS.RECALL) {
						oldMessage.status = this.$enums.MESSAGE_STATUS.READED;
					}
					if (message.sourceMessage && !oldMessage.sourceMessage) {
						oldMessage.sourceMessage = message.sourceMessage;
					}
					return;
				}
				if (key) {
					exists.set(key, message);
				}
				result.push(message);
			});
			return result;
		},
		getLastReadedMessageIdx(messages = []) {
			let idx = 0;
			messages.forEach((message, index) => {
				if (message.selfSend && message.status === this.$enums.MESSAGE_STATUS.READED) {
					idx = index;
				}
			});
			return idx;
		},
		async loadHistoryMessages(scrollElement) {
			if (this.historyLoading || this.historyFinished || !this.chat?.messages?.length) {
				return;
			}
			const anchorMessage = this.chat.messages.find(message => message.sourceMessage);
			if (!anchorMessage) {
				this.historyFinished = true;
				return;
			}
			this.historyLoading = true;
			const oldScrollHeight = scrollElement?.scrollHeight || 0;
			try {
				const messages = await this.$yunxinIM.getHistoryMessages(this.chat, anchorMessage, 50);
				const currentMessages = (this.chat.messages || []).filter(message => message.type !== this.$enums.MESSAGE_TYPE.TIP_TIME);
				const exists = new Set(currentMessages.map(message => String(message.id || message.tmpId)));
				const prependMessages = messages.filter(message => !exists.has(String(message.id || message.tmpId)));
				if (prependMessages.length) {
					this.chat.messages = this.buildMessagesWithTimeTips(prependMessages.concat(currentMessages));
					this.chat.readedMessageIdx = this.getLastReadedMessageIdx(this.chat.messages);
					this.chat.stored = false;
					this.chatStore.saveToStorage(true);
					this.showMinIdx = 0;
					this.$nextTick(() => {
						const div = scrollElement || document.getElementById('chatScrollBox');
						if (div) {
							div.scrollTop = div.scrollHeight - oldScrollHeight + 30;
						}
					});
				}
				if (messages.length < 50 || !prependMessages.length) {
					this.historyFinished = true;
				}
			} catch (error) {
				console.warn('[ChatBox] 加载历史消息失败:', error);
			} finally {
				this.historyLoading = false;
			}
		},
		showName(msgInfo) {
			if (!msgInfo) {
				return ""
			}
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				const name = member ? member.showNickName : msgInfo.sendNickName || "";
				return this.isIdLikeName(name, msgInfo.sendId) ? "" : name;
			} else {
				return this.isMineMessage(msgInfo) ? this.mine.nickName : this.chat.showName
			}
		},
		headImage(msgInfo) {
			if (this.isGroup) {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.headImage : "";
			} else {
				return this.isMineMessage(msgInfo) ? this.mine.headImageThumb : this.chat.headImage
			}
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		scrollToBottom() {
			this.resetShowMessages();
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				if (div) {
					div.scrollTop = div.scrollHeight;
				}
			});
		},
		refreshPlaceHolder() {
			if (this.isReceipt) {
				this.placeholder = "[回执消息]"
			} else if (this.$refs.editBox && this.$refs.editBox.innerHTML) {
				this.placeholder = ""
			} else {
				this.placeholder = "聊点什么吧~";
			}
		},
		sendMessageRequest(msgInfo) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				this.reqQueue.push({ msgInfo, resolve, reject });
				this.processReqQueue();
			})
		},
		processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				this.$http({
					url: this.messageAction,
					method: 'post',
					data: reqData.msgInfo
				}).then((res) => {
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
			}
		},
		buildTmpMessage(msgInfo) {
			let message = JSON.parse(JSON.stringify(msgInfo));
			message.sendId = this.mine.imAccid || this.mine.accountId || this.$yunxinIM.currentAccount || this.mine.id;
			message.sendTime = new Date().getTime();
			message.status = this.$enums.MESSAGE_STATUS.SENDING;
			message.selfSend = true;
			if (this.isGroup) {
				message.readedCount = 0;
			}
			return message;
		},
		getImageSize(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = function (event) {
					const img = new Image();
					img.onload = function () {
						resolve({ width: img.width, height: img.height });
					};
					img.onerror = function () {
						reject(new Error('无法加载图片'));
					};
					img.src = event.target.result;
				};
				reader.onerror = function () {
					reject(new Error('无法读取文件'));
				};
				reader.readAsDataURL(file);
			});
		},
		getVideoSize(file) {
			return new Promise((resolve) => {
				const url = URL.createObjectURL(file);
				const video = document.createElement('video');
				video.onloadedmetadata = () => {
					resolve({
						width: video.videoWidth,
						height: video.videoHeight
					});
					URL.revokeObjectURL(url);
				};
				video.src = url;
			});
		},
		generateId() {
			// 生成临时id 
			const id = String(new Date().getTime()) + String(Math.floor(Math.random() * 1000));
			// 必须保证id是递增
			if(this.maxTmpId > id){
				return this.generateId();
			}
			this.maxTmpId = id;
			return id;
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		friendLookupIds() {
			return [
				this.chat && this.chat.targetId,
				this.userInfo.id,
				this.userInfo.imAccid,
				this.userInfo.accountId,
				this.userInfo.accid
			].filter(Boolean);
		},
		isFriend() {
			return this.friendLookupIds.some(id => this.friendStore.isFriend(id));
		},
		friend() {
			for (const id of this.friendLookupIds) {
				const friend = this.friendStore.findFriend(id);
				if (friend && !friend.deleted) {
					return friend;
				}
			}
			return {}
		},
		privateOnlineStatusText() {
			if (!this.friend.online) {
				return '离线';
			}
			const devices = [];
			if (this.friend.onlineWeb) {
				devices.push('电脑端');
			}
			if (this.friend.onlineApp) {
				devices.push('移动端');
			}
			return devices.length ? `在线（${devices.join('、')}）` : '在线';
		},
		privateIpText() {
			return this.userInfo.lastLoginIp || this.userInfo.loginIp || this.userInfo.ipAddress || this.userInfo.ip ||
				this.friend.lastLoginIp || this.friend.loginIp || this.friend.ipAddress || this.friend.ip || '';
		},
		privateAreaText() {
			return this.userInfo.lastLoginArea || this.friend.lastLoginArea || '';
		},
		group() {
			return this.groupStore.findGroup(this.groupId) || {}
		},
		groupMembers() {
			return this.group.members || [];
		},
		title() {
			let title = this.chat.showName;
			if (this.isGroup) {
				let size = this.groupMembers.filter(m => !m.quit).length;
				title += `(${size})`;
			}
			return title;
		},
		messageAction() {
			return `/message/${this.chat.type.toLowerCase()}/send`;
		},
		unreadCount() {
			return this.chat.unreadCount;
		},
		showMessages() {
			if (this.showMaxIdx > 0) {
				return this.chat.messages.slice(this.showMinIdx, this.showMaxIdx)
			} else {
				return this.chat.messages.slice(this.showMinIdx)
			}
		},
		messageSize() {
			if (!this.chat || !this.chat.messages) {
				return 0;
			}
			return this.chat.messages.length;
		},
		isGroup() {
			return this.chat.type == 'GROUP';
		},
		isPrivate() {
			return this.chat.type == 'PRIVATE';
		},
		isOwner() {
			return String(this.group.ownerId || '') === String(this.mineAccountId || '');
		},
		isManager() {
			let m = this.groupMembers.find(m => String(m.userId || '') === String(this.mineAccountId || ''));
			return m && m.isManager;
		},
		mineAccountId() {
			return this.mine.imAccid || this.mine.accountId || this.mine.id || this.$yunxinIM.currentAccount;
		},
		canShareContactCard() {
			return !this.isGroup || this.isOwner || this.isManager || this.group.isAllowShareCard;
		},
		loading() {
			return this.chatStore.loading;
		},
		notAllowInputTip() {
			if (this.isGroup) {
				if (this.group.dissolve) {
					return "群聊已解散"
				} else if (this.group.quit) {
					return "您已不在群聊中"
				} else if (this.group.isBanned) {
					return "群聊已被封禁,原因:" + this.group.reason
				} else if (this.group.isAllMuted && !this.isOwner && !this.isManager) {
					return "全员禁言中，只有群主和管理员发言"
				} else if (this.group.isMuted) {
					return "您已被群管理员禁言"
				}
			} else if (this.userInfo.isBanned) {
				return "对方账号已被封禁,原因:" + this.userInfo.reason
			}
			return "";
		}
	},
	watch: {
		chat: {
			handler(newChat, oldChat) {
				if (newChat && newChat.targetId && (!oldChat || newChat.type != oldChat.type ||
					newChat.targetId != oldChat.targetId)) {
					this.userInfo = {};
					this.groupId = null;
					if (this.isGroup) {
						this.loadGroup(this.chat.targetId);
					} else {
						this.loadFriend(this.chat.targetId);
						// 加载已读状态
						this.loadReaded(this.chat.targetId)
					}
					this.loadRecentMessages();
					// 滚到底部
					this.scrollToBottom();
					this.showSide = false;
					// 消息已读
					this.readedMessage()
					// 初始状态只显示30条消息
					this.resetShowMessages();
					// 重置输入框
					this.resetEditor();
					// 复位回执消息
					this.isReceipt = false;
					// 清空引用消息
					this.quoteMessage = null;
					// 复位底部标记
					this.isInBottom = true;
					this.newMessageSize = 0;
					// 清空消息临时id
					this.maxTmpId = 0;
					this.historyLoading = false;
					this.historyFinished = false;
					// 更新placeholder
					this.refreshPlaceHolder();
				}
			},
			immediate: true
		},
		messageSize: {
			handler(newSize, oldSize) {
				if (newSize > oldSize) {
					// 收到普通消息,则滚动至底部
					let lastMessage = this.chat.messages[newSize - 1];
					if (lastMessage && this.$msgType.isNormal(lastMessage.type) || this.$msgType.isAction(lastMessage.type)) {
						if (this.isInBottom || lastMessage.selfSend) {
							this.scrollToBottom();
						} else {
							this.newMessageSize++;
						}
					}
				}
			}
		},
		loading: {
			handler(newLoading, oldLoading) {
				// 断线重连后，需要更新一下已读状态
				if (!newLoading && this.isPrivate) {
					this.loadReaded(this.chat.targetId)
				}
			}
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
	}
}
</script>

<style lang="scss">
.chat-box {
	position: relative;
	width: 100%;
	
	/* 简化的底部操作栏样式 */
	.multi-select-bar-bottom {
	background: #fff;
	border-top: 1px solid #e4e7ed;
	padding: 10px 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-shadow: 0 -2px 12px 0 rgba(0, 0, 0, 0.1);
	position: relative;
	z-index: 100;
	width: 100%;
	box-sizing: border-box;
	}
	
	/* 清空之前的样式定义，避免冲突 */
	.multi-select-bar {
	/* 样式已移至 .multi-select-bar-bottom */
	}
	
	/* 多选模式下的遮罩 */
	.multi-select-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
	}

	.el-header {
		display: flex;
		padding: 0 12px;
		line-height: 60px;
		border-bottom: var(--im-border);

		.chat-title-wrap {
			display: flex;
			align-items: center;
			min-width: 0;
			padding-right: 36px;

			.title {
				font-size: var(--im-font-size-larger);
				white-space: nowrap;
			}

			.private-status-meta {
				display: flex;
				align-items: center;
				gap: 6px;
				min-width: 0;
				margin-left: 12px;
				font-size: var(--im-font-size-small);
				color: var(--im-text-color-light);
				line-height: 60px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.status-dot {
				width: 8px;
				height: 8px;
				border-radius: 50%;
				background: #b8bec8;
				flex: 0 0 auto;

				&.online {
					background: #13ce66;
				}

				&.offline {
					background: #b8bec8;
				}
			}

			.status-text {
				color: var(--im-text-color);
			}

			.meta-divider {
				color: #d0d4dc;
			}
		}


		.btn-side {
			position: absolute;
			right: 20px;
			line-height: 60px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
		}
	}

	.chat-layout {
		min-width: 0;
		overflow: hidden;
	}

	.content-box {
		position: relative;
		display: flex;
		flex: 1 1 0;
		flex-direction: column;
		width: 0;
		min-width: 0;
		overflow: hidden;

		&.has-announcement {
			padding-top: 42px;
		}

		.chat-announcement-fixed {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			width: auto;
			max-width: none;
			z-index: 3;
		}

		.chat-group-top {
			flex: 0 0 auto;
			min-width: 0;
			width: 100%;
			max-width: 100%;
			overflow: hidden;
		}

		.im-chat-main {
			padding: 0 10px;
			background: #f6f7f8;
		}

		.locate-tip {
			text-align: center;
			position: absolute;
			right: 20px;
			bottom: 230px;
			color: var(--im-color-primary);
			font-size: var(--im-font-size);
			font-weight: 600;
			background: white;
			padding: 8px 16px;
			border-radius: 18px;
			cursor: pointer;
			z-index: 99;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
			transition: all 0.3s ease;
			border: 1px solid rgba(0, 0, 0, 0.06);

			&:hover {
				transform: translateY(-1px);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
			}

		}

		.im-chat-footer {
			position: relative;
			display: flex;
			flex-direction: column;
			padding: 0;

			.chat-tool-bar {
					display: flex;
					position: relative;
					width: 100%;
					height: 44px;
					text-align: left;
					box-sizing: border-box;
					border-top: 2px solid #EBEEF5;
					padding: 6px 8px;
					align-items: center;
					background: var(--im-background-active);
					color: black;
					opacity: 0.85;

					// 统一所有按钮的样式
					>div,
					>i {
						font-size: 20px;
						cursor: pointer;
						width: 32px;
						height: 32px;
						line-height: 32px;
						text-align: center;
						border-radius: 6px;
						margin-right: 8px; // 使用margin-right代替gap以获得更一致的间距

						transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
						display: flex;
						align-items: center;
						justify-content: center;
						position: relative;

						&.chat-tool-active {
							color: var(--im-color-primary);
							background: var(--im-background-active-dark);
							transform: scale(1.02);

						}

						&:hover {
							color: var(--im-color-primary);
							background: var(--im-background-active);
							transform: translateY(-1px);
							box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
						}
					}

					// 特殊处理小图标（如el-icon-caret-bottom）
					>i.el-icon-caret-bottom {
						font-size: 14px;
						width: 24px;
						height: 24px;
						line-height: 24px;
						margin-right: 0; // 移除这个小图标的右边距，因为它是跟在其他图标后面的
					}
			}

			.send-content-area {
				position: relative;
				display: flex;
				flex-direction: column;
				height: 100%;
				background-color: white !important;

				.quote-message {
					position: absolute;
					bottom: 10px;
					left: 10px;
					font-size: 14px;
					max-width: 80%;
					border-radius: 5px;

					&:hover .quote-remove {
						display: block;
					}

					.quote-remove {
						display: none;
						position: absolute;
						top: -8px;
						right: -8px;
						width: 20px;
						height: 20px;
						line-height: 20px;
						font-size: 14px;
						color: white;
						border-radius: 50%;
						background: #aaa;
						cursor: pointer;

						&:hover {
							background: #888;
						}

					}
				}

				.send-btn-area {
					padding: 10px;
					position: absolute;
					bottom: 4px;
					right: 6px;
				}
			}

			.chat-editer-mask {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: #f8f8f8d0;
				font-size: var(--im-font-size-large);
				color: var(--im-text-color-light);
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 10px;
				border: 1px solid #ddd;

				.icon {
					font-size: var(--im-font-size-larger);
					margin-right: 3px;
				}
			}
		}
	}

	.chat-side-box {
		flex: 0 0 265px;
		width: 265px !important;
		min-width: 265px;
		max-width: 265px;
		border-left: var(--im-border);
		background: #f6f7f8;
		transform-origin: right center;

		&.fullscreen {
			width: 335px !important;
			flex-basis: 335px;
			min-width: 335px;
			max-width: 335px;
		}
	}

	.chat-side-slide-enter-active,
	.chat-side-slide-leave-active {
		transition: transform 0.22s ease, opacity 0.22s ease;
	}

	.chat-side-slide-enter,
	.chat-side-slide-leave-to {
		opacity: 0;
		transform: translateX(100%);
	}

	.chat-side-slide-enter-to,
	.chat-side-slide-leave {
		opacity: 1;
		transform: translateX(0);
	}
}
</style>
